import axios from 'axios'
import { hydraUrl, memberCalls2Url } from '@helpers'

const customerLogin = ({ username, password }: { username: string; password: string }) => {
    const url = hydraUrl({
        path: 'loginTokens'
    })

    return axios.post(url, {
        type: 'base64',
        value: btoa(`${username}:${password}`),
        namespace: 'https://hydra.unicity.net/v5a/customers'
    })
}

const loginToken = ({ username, password }: { username: string; password: string }) => {
    const url = memberCalls2Url({
        path: '/dsc-tool-v2/THA/login'
    })

    return axios.post(url, {
        value: btoa(`${username}:${password}`)
    })
}

const employeeLogin = ({ username, password }: { username: string; password: string }) => {
    const url = hydraUrl({
        path: '/v5a/employees/login'
    })

    return axios.post(
        url,
        {
            username,
            password
        },
        {
            headers: {
                'x-application': 'asia.dsc-tools'
            }
        }
    )
}

const fetchCustomer = ({ hydraToken, href }: { hydraToken: string; href: string }) => {
    return axios.get(href, {
        headers: {
            authorization: `Bearer ${hydraToken}`,
            'x-application': 'asia.dsc-tools'
        }
    })
}

const whoAmI = ({ token }: { token: string }) => {
    const url = hydraUrl({
        path: 'whoami'
    })

    return axios.get(url, {
        headers: {
            authorization: `Bearer ${token}`,
            'x-application': 'asia.dsc-tools'
        }
    })
}

export const autoLogin = ({ token }: { token: string }) => {
    const url = memberCalls2Url({
        path: `/hot/remoteStorage/broker/${token}`
    })

    return axios.get(url)
}

export type TRefreshTokenProps = { countryCode3alpha: string; baId: string; loginId: string; token: string }
export const refreshToken = ({ countryCode3alpha, baId, loginId, token }: TRefreshTokenProps) => {
    const url = memberCalls2Url({
        path: `/etlV2/refreshToken?ushopCountryCode=${countryCode3alpha}&baId=${baId}&login_id=${loginId}`
    })

    return axios.get(url, {
        timeout: 30000,
        headers: {
            'authorization-hydra': `Bearer ${token}`
        }
    })
}

export type TOnselfProps = { countryCode3alpha: string; baId: string; token: string }
export const onself = ({ countryCode3alpha, baId, token }: TOnselfProps) => {
    const url = memberCalls2Url({
        path: `/etlV2/onself?ushopCountryCode=${countryCode3alpha}&baId=${baId}&collapse=hydra`
    })

    return axios.get(url, {
        headers: {
            'authorization-hydra': token
        }
    })
}

export const authenticationApi = {
    loginToken,
    autoLogin,
    refreshToken,
    onself,
    employeeLogin,
    fetchCustomer,
    whoAmI,
    customerLogin
}
